import React, {useEffect} from 'react';
import {useSelector} from "react-redux";
import {get, filter, mean, map} from 'lodash';
import Highcharts from 'highcharts';
import HC_more from 'highcharts/highcharts-more';
HC_more(Highcharts);

export default function ({printable, dataType, student_name}) {

    const dashboard = useSelector(state => state.insights_dashboard);
    const dashboard_data = useSelector(state => state.dashboard_data);

    const graph_id = 'pam-student-graph';
    const data_skill_table = dashboard_data.data_skill_table;
    // console.log('data_skill_table', data_skill_table);

    useEffect(() => {
        if (data_skill_table) {
            draw();
        }
    }, [data_skill_table]);

    if (data_skill_table === undefined) {
        return null;
    }

    // Compute graph data
    const skills = get(data_skill_table, ['items', 0, 'skills']);
    const skills_computed = map(skills, (skill, skill_code) => {
        const percentage_array = data_skill_table.items.map((item) => get(item, ['skills', skill_code, 'percentage']));
        const percentage = Math.ceil(mean(filter(percentage_array, (p) => p != null)));
        return {
            ...skill,
            skill_code,
            percentage
        };
    });
    const categories = map(skills_computed, (s) => `${s.skill_code}: ${s.name}`);
    const data = map(skills_computed, (s) => s.percentage);
    while (categories.length < 6) {
        categories.push('-');
        data.push(50);
    }

    function draw() {
        const graph = {
            chart: {
                polar: true,
                type: 'line',
                height: 550
            },
            title: {
                text: 'Student Achievement',
                style: {
                    fontWeight: 'bolder',
                    fontSize: '18px'
                }
            },
            pane: {
                // size: '80%'
            },
            xAxis: {
                categories: categories,
                tickmarkPlacement: 'on',
                lineWidth: 0,
                labels: {
                    style: {}
                }
            },
            yAxis: {
                gridLineInterpolation: 'polygon',
                lineWidth: 0,
                min: 0,
                max: 100,
                labels: {
                    enabled: false,
                    format: '{text}%'
                }
            },
            // tooltip: {
            //     pointFormat: '<span>{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
            //     shared: true
            // },
            series: [{
                name: `Student: ${student_name}`,
                data,
                pointPlacement: 'on',
                color: '#74C043'
            }],
            // legend: {
            //     enabled: true,
            //     reversed: true
            // },
            credits: {
                enabled: false
            }
        }

        if (printable) {
            graph.tooltip.enabled = false;
        }

        Highcharts.chart(graph_id, graph)
    }

    return (
        <div>
            <div id={graph_id} />
        </div>
    );
}
